import { render, staticRenderFns } from "./grid-amount.vue?vue&type=template&id=4d7d0462"
import script from "./grid-amount.ts?vue&type=script&lang=js&external"
export * from "./grid-amount.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports